import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React from "react";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

function SignIn() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  //use auth
  const { tokenExpiration } = useSelector((state: RootState) => state.auth);

  const accounts = instance.getAllAccounts();
  if (accounts.length === 0) {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      // await instance.loginRedirect(loginRequest);
    }
  }
  //if token expired, redirect to login
  if (tokenExpiration && new Date(tokenExpiration) < new Date()) {
    //instance.loginRedirect(loginRequest);
  }

  // React.useEffect(() => {
  //   debugger;
  //   if (inProgress === InteractionStatus.None && !user) {
  //     instance.loginRedirect(loginRequest).catch((e) => {
  //       console.error("Login redirect failed", e);
  //     });
  //   } else if (inProgress === InteractionStatus.Logout) {
  //     window.location.href = "/logged-out";
  //   }
  // }, [instance, inProgress]);

  return <div></div>;
  // return <div>Redirecting to login...</div>;
}

export default SignIn;
